<template>
  <template
    v-if="vueProps.sidebarLink.childLinks?.length === 0"
  >
    <v-list-item
      v-if="vueProps.sidebarLink.extarnal_link"
      :prepend-icon="vueProps.sidebarLink.icon"
      :href="vueProps.sidebarLink.path"
      target="_blank"
      :title="vueProps.sidebarLink.name"
    />
    <v-list-item
      v-else
      :prepend-icon="vueProps.sidebarLink.icon"
      :to="vueProps.sidebarLink.path"
      :title="vueProps.sidebarLink.name"
      :class="{ grandChild: nestLevel === 2 }"
    >
      <v-tooltip 
        activator="parent"
        v-if="vueProps.sidebarLink.tooltip"
        :theme="tooltipTheme"
        :location="tooltipLocation"
        :open-delay="500"
      >
        <span>{{ vueProps.sidebarLink.tooltip }}</span>
      </v-tooltip>
    </v-list-item>
  </template>
  <v-list-group
    v-else
  >
    <template v-slot:activator="{ props }">
      <v-list-item
        v-bind="props"
        :prepend-icon="vueProps.sidebarLink.icon"
        :title="vueProps.sidebarLink.name"
      ></v-list-item>
    </template>
    <SideBarLinkItem
      v-for="childLink in vueProps.sidebarLink.childLinks"
      :key="childLink.name"
      :sidebar-link="childLink"
      :nest-level="nestLevel + 1"
    />
  </v-list-group>
</template>

<style scoped>
.grandChild {
  padding-inline-start: calc(var(--parent-padding)) !important;
}
</style>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import { SidebarLink } from '@/router/sidebarLinksCreator';
import { useDisplay } from 'vuetify';

const vueProps = defineProps<{
  sidebarLink: SidebarLink;
  nestLevel: number;
}>();

const xs = useDisplay().xs;

const tooltipLocation = computed<string>(() => {
  if (xs.value) {
    return 'top';
  }
  return 'right';
});
const tooltipTheme = computed<string>(() => {
  if (xs.value) {
    return 'dark';
  }
  return 'light';
});
</script>